import _suggestInfoCircleLine from "@zenlayer/zen-design-icons/assets/suggest/InfoCircleLine.svg";
import { useCreation } from 'ahooks';
import classnames from 'classnames';
import { isNone } from '../_util/defineType';
import Checkbox from '../checkbox';
import HelpInfo from '../help-info';
import Icon from '../icon';
import Tooltip from '../tooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TypographyTitle = props => {
  const {
    type = 'inherit',
    size = '20-24',
    checkbox,
    info,
    help,
    extra,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-typography-title");
  const childrenElement = useCreation(() => /*#__PURE__*/_jsxs("div", {
    className: classnames('content', "size-".concat(size), "type-".concat(type)),
    children: [/*#__PURE__*/_jsx("div", {
      children: children
    }), !isNone(info) && /*#__PURE__*/_jsx(Tooltip, {
      title: info,
      children: /*#__PURE__*/_jsx(Icon, {
        type: "suggest/InfoCircleLine",
        className: "icon-tooltip"
      })
    }), !!help && /*#__PURE__*/_jsx(HelpInfo, {
      ...help,
      className: "icon-tooltip"
    })]
  }), [size, type, children, info, help]);
  return /*#__PURE__*/_jsxs("div", {
    ...restProps,
    className: classnames(baseClassName, className),
    style: style,
    children: [checkbox ? /*#__PURE__*/_jsx(Checkbox, {
      shape: "circular",
      ...checkbox,
      style: {
        display: 'flex',
        ...checkbox.style
      },
      children: childrenElement
    }) : childrenElement, !isNone(extra) && /*#__PURE__*/_jsx("div", {
      className: "extra",
      children: extra
    })]
  });
};
export default TypographyTitle;